import { useEffect, useState } from "react";
import { Trash2, Mail } from "lucide-react";
import { api } from "../../lib/api";

export const MessagesPanel = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/messages").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-messages">
      <h2 className="font-display text-2xl font-bold text-[#0B1F44] mb-6">Contact Messages</h2>
      <div className="space-y-3">
        {items.length === 0 && <p className="bg-white rounded-2xl border border-slate-200 p-8 text-center text-slate-500">No messages yet.</p>}
        {items.map((m) => (
          <div key={m.id} className="bg-white rounded-2xl border border-slate-200 p-5" data-testid={`message-${m.id}`}>
            <div className="flex justify-between gap-4">
              <div>
                <p className="font-semibold text-[#0B1F44]">{m.subject || "(no subject)"}</p>
                <p className="text-sm text-slate-500 flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" />{m.name} · {m.email} {m.phone && `· ${m.phone}`}</p>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-xs text-slate-400">{new Date(m.created_at).toLocaleString("en-IN")}</span>
                <button onClick={() => api.delete(`/messages/${m.id}`).then(load)} className="p-1.5 rounded-lg hover:bg-red-50 text-red-600" data-testid={`message-delete-${m.id}`}><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            <p className="mt-3 text-sm text-slate-700 whitespace-pre-line">{m.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
